(function (w, d) {
  'use strict';

  var boot = d.getElementById('es-pdp-runtime');
  if (!boot || boot.getAttribute('data-es-booted') === '1') return;
  boot.setAttribute('data-es-booted', '1');

  function attr(name) {
    return boot.getAttribute(name) || '';
  }

  function removeNode(node) {
    try { if (node && node.parentNode) node.parentNode.removeChild(node); } catch (_err) {}
  }

  var config = {
    sizeGuideJs: attr('data-size-guide-js'),
    tryonCss: attr('data-tryon-css'),
    tryonJs: attr('data-tryon-js'),
    relatedCss: attr('data-related-css'),
    relatedJs: attr('data-related-js'),
    quickviewCss: attr('data-quickview-css'),
    quickviewJs: attr('data-quickview-js'),
    quickviewLensJs: attr('data-quickview-lens-js'),
    lensbuilderCss: attr('data-lensbuilder-css'),
    lensbuilderJs: attr('data-lensbuilder-js'),
    fancyboxUmd: attr('data-fancybox-umd'),
    fancyboxBinder: attr('data-fancybox-binder'),
    stickySyncJs: attr('data-sticky-sync-js'),
    hasLensbuilder: attr('data-has-lensbuilder') === '1'
  };

  w.__ES_PDP_LAZY_ASSETS = {
    relatedCss: config.relatedCss,
    relatedJs: config.relatedJs,
    quickviewCss: config.quickviewCss,
    quickviewJs: config.quickviewJs,
    quickviewLensJs: config.quickviewLensJs,
    lensbuilderCss: config.lensbuilderCss,
    lensbuilderJs: config.lensbuilderJs,
    fancyboxUmd: config.fancyboxUmd,
    fancyboxBinder: config.fancyboxBinder,
    hasLensbuilder: config.hasLensbuilder
  };

  // Keep resource tracking on the DOM node so a timed-out wait can be retried
  // without inserting a second script that might execute alongside the first.
  if (typeof w.__ES_PDP_RUNTIME_CLEANUP__ === 'function') w.__ES_PDP_RUNTIME_CLEANUP__();
  var active = true;
  var suspended = false;
  var cleanups = [];
  var clearIntents = [];
  var resumeTasks = [];
  var waitCancels = new Set();

  function listen(target, name, handler, options) {
    target.addEventListener(name, handler, options);
    cleanups.push(function () { target.removeEventListener(name, handler, options); });
  }

  function canAct() {
    return active && !suspended && boot.isConnected && d.visibilityState !== 'hidden';
  }

  function cancelPending() {
    clearIntents.forEach(function (clear) { clear(); });
    waitCancels.forEach(function (cancel) { cancel(); });
  }

  w.__ES_PDP_RUNTIME_CLEANUP__ = function () {
    active = false;
    cancelPending();
    cleanups.splice(0).forEach(function (cleanup) { cleanup(); });
  };

  function assetReady(node, type) {
    return node.getAttribute('data-es-loaded') === '1' ||
      (type === 'link' ? !!node.sheet : node.readyState === 'loaded' || node.readyState === 'complete');
  }

  function loadAsset(type, src, marker, filename, present) {
    if (present && present()) return Promise.resolve();
    var node = d.querySelector(type + '[' + marker + ']');
    if (node && node.getAttribute('data-es-load-failed') === '1') {
      removeNode(node);
      node = null;
    }
    var created = !node;
    if (!node) {
      node = d.createElement(type);
      if (type === 'link') { node.rel = 'stylesheet'; node.href = src; }
      else { node.src = src; node.async = true; }
      node.setAttribute(marker, filename);
    }
    if (assetReady(node, type)) return Promise.resolve();
    if (node.__esPdpWait) return node.__esPdpWait.promise;

    if (!node.__esPdpTracked) {
      node.__esPdpTracked = true;
      var trackDone = function () {
        node.setAttribute('data-es-loaded', '1');
        stopTracking();
      };
      var trackFail = function () {
        node.setAttribute('data-es-load-failed', '1');
        stopTracking();
        removeNode(node);
      };
      var stopTracking = function () {
        node.removeEventListener('load', trackDone);
        node.removeEventListener('error', trackFail);
      };
      node.addEventListener('load', trackDone, { once: true });
      node.addEventListener('error', trackFail, { once: true });
    }

    var entry = {};
    entry.promise = new Promise(function (resolve, reject) {
      var timer = 0;
      var settled = false;
      function finish(error) {
        if (settled) return;
        settled = true;
        w.clearTimeout(timer);
        node.removeEventListener('load', onLoad);
        node.removeEventListener('error', onError);
        waitCancels.delete(entry.cancel);
        if (node.__esPdpWait === entry) node.__esPdpWait = null;
        if (error) reject(error); else resolve();
      }
      function onLoad() { finish(); }
      function onError() { finish(new Error(filename + ' failed to load')); }
      entry.cancel = function () { finish(new Error(filename + ' wait cancelled')); };
      node.addEventListener('load', onLoad, { once: true });
      node.addEventListener('error', onError, { once: true });
      waitCancels.add(entry.cancel);
      timer = w.setTimeout(function () {
        finish(assetReady(node, type) ? null : new Error(filename + ' loading timed out'));
      }, 15000);
    });
    node.__esPdpWait = entry;
    if (created) {
      try { (d.head || d.documentElement).appendChild(node); }
      catch (_appendError) {
        node.setAttribute('data-es-load-failed', '1');
        stopTracking();
        removeNode(node);
        entry.cancel();
      }
    }
    return entry.promise;
  }

  function bindIntent(selector, isReady, resources) {
    var ready = isReady();
    var promise = null;
    var pending = null;
    clearIntents.push(function () { pending = null; });

    function load() {
      if (ready) return Promise.resolve();
      if (promise) return promise;
      promise = Promise.all(resources()).then(function () {
        ready = true;
      }).catch(function (error) {
        promise = null;
        throw error;
      });
      return promise;
    }

    function findTrigger(target) {
      return target && target.closest ? target.closest(selector) : null;
    }
    function warm(event) {
      if (canAct() && findTrigger(event.target)) load().catch(function () {});
    }
    function click(event) {
      var button = findTrigger(event.target);
      if (!button || ready || !canAct()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      var intent = { button: button };
      pending = intent;
      load().then(function () {
        if (pending !== intent) return;
        pending = null;
        if (canAct() && button.isConnected &&
            !button.closest('[hidden], [inert], [aria-hidden="true"]') && !button.disabled) button.click();
      }).catch(function () {
        if (pending === intent) pending = null;
      });
    }
    listen(d, 'pointerover', warm, true);
    listen(d, 'focusin', warm, true);
    listen(d, 'touchstart', warm, { capture: true, passive: true });
    listen(d, 'click', click, true);
  }

  if (config.sizeGuideJs) {
    var guidePresent = function () { return !!w.__ES_SIZE_GUIDE_BOOT__; };
    bindIntent('[data-es-size-guide-open]', guidePresent, function () {
      return [loadAsset('script', config.sizeGuideJs, 'data-es-size-guide-runtime', 'es-size-guide.js', guidePresent)];
    });
  }

  if (config.tryonCss && config.tryonJs) {
    var tryonPresent = function () { return !!w.__ES_TRYON_CLEAN_LOADED__; };
    bindIntent('[data-es-tryon-open]', function () {
      var style = d.querySelector('link[data-es-tryon-runtime-style]');
      return tryonPresent() && !!style && assetReady(style, 'link');
    }, function () {
      return [loadAsset('link', config.tryonCss, 'data-es-tryon-runtime-style', 'es-tryon-clean.css'),
        loadAsset('script', config.tryonJs, 'data-es-tryon-runtime-script', 'es-tryon-clean.js', tryonPresent)];
    });
  }

  if (config.stickySyncJs) {
    var stickyLoading = false;
    var stickyLoaded = false;
    var media = null;
    try { media = w.matchMedia ? w.matchMedia('(min-width: 768px)') : null; } catch (_mediaError) {}
    var loadSticky = function () {
      if (!canAct() || stickyLoaded || stickyLoading || (media && !media.matches)) return;
      stickyLoading = true;
      loadAsset('script', config.stickySyncJs, 'data-es-pdp-sticky-sync-asset', 'es-pdp-sticky-sync.js').then(function () {
        stickyLoading = false;
        stickyLoaded = true;
      }).catch(function () { stickyLoading = false; });
    };
    loadSticky();
    resumeTasks.push(loadSticky);
    if (media && media.addEventListener) listen(media, 'change', loadSticky);
    else if (media && media.addListener) {
      media.addListener(loadSticky);
      cleanups.push(function () { media.removeListener(loadSticky); });
    }
  }

  listen(w, 'pagehide', function () { suspended = true; cancelPending(); });
  listen(w, 'pageshow', function () {
    suspended = false;
    if (canAct()) resumeTasks.forEach(function (resume) { resume(); });
  });
  listen(d, 'visibilitychange', function () {
    if (d.visibilityState === 'hidden') cancelPending();
    else if (canAct()) resumeTasks.forEach(function (resume) { resume(); });
  });
})(window, document);
